import React from 'react';
import { Icons, Button } from "@curves/ui-base";
import clsx from 'clsx';

const FocusModeToggleButton = ({ className, isFocusMode, onClick, ...rest }) => {
    return (
        <Button
            className={clsx('focus-mode-button', className)}
            variant={isFocusMode ? 'contained' : 'outlined'}
            color={'secondary'}
            startIcon={isFocusMode ? <Icons.Minus /> : <Icons.Fullscreen />}
            onClick={onClick}
            {...rest}
        >
{isFocusMode ? '退出專注' : '啟用專注'}
        </Button>
    );
};

export default FocusModeToggleButton;
